export const FJ_EVENT_TYPE = {
    HIDE_QUICK_SELECTION_BOX: 'HIDE_QUICK_SELECTION_BOX',
    HIDE_SIDE_MODAL: 'HIDE_SIDE_MODAL',

    START_RECORDER: 'START_RECORDER',
    STOP_AUDIO_IN_TTS: 'STOP_AUDIO_IN_TTS',
    STOP_PREVIEW_VOICE_IN_TTS: 'STOP_PREVIEW_VOICE_IN_TTS',
    EDIT: 'EDIT',
    ADD: 'ADD',
    DELETE: 'DELETE',
    MOVE: 'MOVE',
    MERGE_PREV: 'MERGE_PREV',
    SPLIT: 'SPLIT',
    UPDATE_MEDIA_PREVIEW_TIME: 'UPDATE_MEDIA_PREVIEW_TIME',
    UPDATE_MEDIA_PREVIEW_PLAYING: 'UPDATE_MEDIA_PREVIEW_PLAYING',
    UPDATE_MEDIA_PREVIEW_DRAGGING: 'UPDATE_MEDIA_PREVIEW_DRAGGING',
    HIDE_ALL_DROP_DOWN: 'HIDE_ALL_DROP_DOWN',
    SET_SCENE_FOCUS: 'SET_SCENE_FOCUS',
    SCROLL_SCENE_TO_END: 'SCROLL_SCENE_TO_END',
    UPDATE_SWIPER_VIEW: 'UPDATE_SWIPER_VIEW',
};
